export default __webpack_public_path__ + "static/media/before-pre-hire-appointment.9aa95ab4.png";